'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--TumblrWithCircle';

var EntypoTumblrWithCircle = function EntypoTumblrWithCircle(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M10,0.4c-5.302,0-9.6,4.298-9.6,9.6s4.298,9.6,9.6,9.6s9.6-4.298,9.6-9.6S15.302,0.4,10,0.4z M12.577,14.141c-0.393,0.188-0.748,0.318-1.066,0.395c-0.318,0.074-0.662,0.113-1.031,0.113c-0.42,0-0.791-0.055-1.114-0.162c-0.323-0.107-0.598-0.26-0.826-0.459c-0.228-0.197-0.386-0.41-0.474-0.633c-0.088-0.225-0.132-0.549-0.132-0.973V9.16H6.918V7.846c0.359-0.119,0.67-0.289,0.927-0.512c0.257-0.221,0.464-0.486,0.619-0.797C8.62,6.227,8.727,5.83,8.786,5.352h1.307v2.35h2.18V9.16h-2.18v2.385c0,0.539,0.028,0.885,0.085,1.037c0.056,0.154,0.161,0.275,0.315,0.367c0.204,0.123,0.437,0.185,0.697,0.185c0.466,0,0.928-0.154,1.388-0.461V14.141z' })
    );
};

exports.default = EntypoTumblrWithCircle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-entypo-icons/lib/entypo/TumblrWithCircle.js
// module id = 7563
// module chunks = 0